export const getCurrentProvider = (): string => {
  const pageURL: string = window.location.href;
  return pageURL.substring(pageURL.lastIndexOf('/') + 1);
};
export default getCurrentProvider;

export const providers: Array<string> = ['all', 'youtube'];
